"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _makeObjectRecord = _interopRequireDefault(require("../record/makeObjectRecord"));

var _ObjectTypes = require("../constants/ObjectTypes");

var _ObjectIds = _interopRequireDefault(require("../constants/ObjectIds"));

var _default = (0, _makeObjectRecord.default)({
  idKey: _ObjectIds.default[_ObjectTypes.TICKET],
  objectType: _ObjectTypes.TICKET,
  recordName: 'TicketRecord',
  defaults: {
    associations: (0, _immutable.Map)(),
    isDeleted: false,
    objectId: null,
    portalId: null,
    properties: (0, _immutable.Map)()
  }
}, {
  primary: ['subject'],
  secondary: ['content']
});

exports.default = _default;
module.exports = exports.default;